import CONSTANTS from '../../constants';

export function posOrders(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.POS.GET.ORDERS:
            return action.posOrders;
        default:
            return state
    }
}

export function posOrder(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.POS.CREATE.ORDER:
            return action.posOrder;
        case CONSTANTS.ACTIONS.POS.GET.ORDER:
            return action.posOrder;
        default:
            return state
    }
}